// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__ynYFO","rotate":"Spinner_rotate__sGN7U","path":"Spinner_path__U8IpG","dash":"Spinner_dash__v5Hnt"};